import MobileServiceClient from "@mocobaas/client-js/build/MobileServiceClient";
import { CreateParams, CreateResult } from "react-admin";
import Mbaas from "./Mbaas";
import { ProviderBase } from "./ProviderBase";
export class OverrideReloadProviderClass extends ProviderBase<any> {
  client: MobileServiceClient;

  constructor(client: MobileServiceClient) {
    super();
    this.client = client;
  }

  async create(resource: string, params: CreateParams): Promise<CreateResult> {
    console.log({ resource, params });
    const { data } = await Mbaas.client.invokeApi("console-validate-totp", {
      token: params.data.totp,
    });
    if (data === "OK") {
      await Mbaas.client
        .invokeApi("console-override-reload", {
          reload_id: params.data.reload_id,
          new_amount: params.data.amount,
          reason: params.data.reason,
        })
        .then((response) => {
          console.log({ response });

          if (response?.error) {
            throw new Error(
              `Override Error: ${
                response.error?.error ? response.error?.error : response.error
              }`
            );
          }
          return response;
        });
    } else {
      throw new Error("TOTP Invalid");
    }
    return {
      data: { ...params.data, id: params.data.reload_id },
    } as CreateResult;
  }
}
